exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".welcome h2,.welcome small{color:#ccc;text-shadow:0 2px 2px #fff}.welcome{padding-top:200px;text-align:center}.welcome h2{font-size:28px}.welcome small{font-size:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/welcome/welcome.scss
// module id = 564
// module chunks = 2